if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      // Delegates to the modal's own <media-gallery data-layout="rail"> instance
      // (see product-media-modal.liquid) so opening the lightbox on a given
      // thumbnail jumps straight to the matching photo/video there too.
      // setActiveMedia() already loads any deferred video/model content for
      // the newly active item (see media-gallery.js's playActiveMedia()).
      showActiveMedia() {
        const mediaId = this.openedBy?.getAttribute('data-media-id');
        const gallery = this.querySelector('media-gallery');
        if (!mediaId || !gallery?.setActiveMedia) return;
        gallery.setActiveMedia(mediaId, false);
      }
    }
  );
}
